'use strict';

var util = angular.module('gymsystem.util');

util.directive('economyoverview', ['$rootScope', '$controller', function($rootScope, $controller) {
    return {
        restrict: 'E',
        templateUrl: 'views/economypanel.html',
        scope: {
            settings: '='
        },
        link: function($scope) {
            $controller('EconomyCtrl', {$scope: $scope});
            $scope.hasPermission = $rootScope.hasPermission;
            $scope.tabVisible = function(tab) {
                return $scope.settings.tabs.indexOf(tab) !== -1;
            };
        }
    };
}]);
